import {
  GET_TENDER_GROUPS,
  DELETE_TENDER_GROUP,
  ERROR_DATA,
  SAVE_TENDER_GROUP,
  UPDATE_TENDER_GROUP,
  GET_TENDER_GROUP,
  CLEAN_TENDER_GROUP,
  SYNCING,
  LOAD_TENDER_GROUPS,
  LOAD_TENDER_GROUP,
  CONTROL_MESSAGE_POPUP,
} from './actionTypes';
import {
  IDeleteTenderGroupsAction,
  ISetTenderGroupAction,
  ISetTenderGroupsAction,
  ISetTenderGroupsErrorAction,
  ITenderGroupAction,
  ITenderGroupItem,
  ITenderGroupsState,
} from './types';
import { IPopUpAction } from 'contexts/Messages/types';

export const initialState: ITenderGroupsState = {
  error: null,
  syncing: false,
  loaded: false,
  messagePopUpState: false,
  tenderGroups: [],
  tenderGroup: {},
};

export const reducer = (
  state: ITenderGroupsState = initialState,
  action: ITenderGroupAction
): ITenderGroupsState => {
  let tenderGroups: ITenderGroupItem[] = [];
  switch (action.type) {
    case LOAD_TENDER_GROUP:
      return { ...state, syncing: true };
    case LOAD_TENDER_GROUPS:
      return { ...state, syncing: true };
    case GET_TENDER_GROUPS:
      return {
        ...state,
        error: null,
        syncing: false,
        tenderGroups: (action as ISetTenderGroupsAction).payload,
        loaded: true,
      };
    case GET_TENDER_GROUP:
      return {
        ...state,
        error: null,
        syncing: false,
        tenderGroup: (action as ISetTenderGroupAction).payload,
        loaded: true,
      };
    case ERROR_DATA:
      return {
        ...state,
        syncing: false,
        error: (action as ISetTenderGroupsErrorAction).payload,
        tenderGroups: [],
      };
    case DELETE_TENDER_GROUP:
      tenderGroups = state.tenderGroups.filter(
        (item) => item.groupId !== (action as IDeleteTenderGroupsAction).payload
      );
      return { ...state, error: null, syncing: false, tenderGroups };
    case SAVE_TENDER_GROUP:
      tenderGroups = state.tenderGroups.filter(() => true);
      tenderGroups.push((action as ISetTenderGroupAction).payload);
      return { ...state, error: null, syncing: false, tenderGroups };
    case UPDATE_TENDER_GROUP:
      const act = action as ISetTenderGroupAction;
      const tenderGroupId = act.payload.groupId;
      tenderGroups = state.tenderGroups.map((item) => {
        if (item.groupId === tenderGroupId) {
          return act.payload;
        }
        return item;
      });
      return { ...state, error: null, syncing: false, tenderGroups };
    case CONTROL_MESSAGE_POPUP:
      return {
        ...state,
        messagePopUpState: (action as IPopUpAction).payload,
      };
    case CLEAN_TENDER_GROUP:
      return {
        ...state,
        error: null,
        tenderGroup: {},
      };
    case SYNCING:
      return { ...state, syncing: true };
    default:
      return state;
  }
};
